module.exports = __webpack_public_path__ + "static/fonts/Metric-Bold.5a07235.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/metric/Metric-Bold.woff
// module id = X0X4
// module chunks = 27